import { EntityTypes } from '../temporary-data-table/components/MoveEntityButton'
import { TemporaryDataType } from '../temporary-data-table/useTemporaryDataState'
import { isTheSameEntity } from './isTheSameEntity'
import { EntityPathMapping } from './pathHierarchyToEntity'

export const entitiesHierarchy = (
    data: TemporaryDataType,
    entity: EntityTypes,
    entityPathMapping: EntityPathMapping[],
    entitiesChecked: (keyof TemporaryDataType)[],
    found: boolean
): void => {
    ;(Object.entries(data) as Array<[keyof TemporaryDataType, EntityDto[]]>).forEach(([entityKey, entityValues]) => {
        if (!found) {
            const foundEntity = entityValues.find((e: EntityDto) => isTheSameEntity(e, entity))
            if (foundEntity) {
                entityPathMapping.push({ entityKey, entity, orderNumber: 0 })
                found = true
                entitiesChecked.push(entityKey as keyof TemporaryDataType)
                entitiesHierarchy(data, entity, entityPathMapping, entitiesChecked, found)
            }
        }

        if (found && !entitiesChecked.includes(entityKey as keyof TemporaryDataType)) {
            const parentEntity = entityValues.find((e: EntityDto) => e.nodeId === entity.parent)

            if (parentEntity) {
                const lastOrderNumber = Math.max(...entityPathMapping.map(e => e.orderNumber))
                entityPathMapping.push({ entityKey, entity: parentEntity, orderNumber: lastOrderNumber + 1 })
                entitiesChecked.push(entityKey as keyof TemporaryDataType)
                entitiesHierarchy(data, parentEntity, entityPathMapping, entitiesChecked, found)
            }
        }
    })
}
